import React, { Component } from 'react'; //different
//import './style.css';
import jwt_decode from "jwt-decode";
import instance from "./axios-instance";
import Swal from 'sweetalert2'
import Systems from "./SystemFunction";
import { json } from 'react-router-dom';
import { LoopTwoTone } from '@mui/icons-material';
import { ToastContainer, toast } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";

class App extends Component {
    constructor(props) {
        super(props)
        this.state = {
            mainsetting: [],
            rewardlist: [],
            activePage: 1,
            pagecount: 1,
            products_page_count: 1,
            isActive: false,
            formData: {}, // Contains login form data
            errors: {}, // Contains login field errors
            formSubmitted: false, // Indicates submit status of login form
            loading: false, // Indicates in progress state of login form
            stateopterror: "",
            stateregis: 1,
            showpass: true,
            lang: window.localStorage.getItem("lang"),
            bankselect: 0,
            trueaccount: true,
            username: null,
            tblbank: [],
            fname: "",
            checkboxacc: 0,
            userid: null,
            phoneNumber: "",
            userrecomend: "",
            logoimg: "",
            linelink: "",
            balance: 0,
            mainacc: null,
            accnumbertxt: "",
        }
        this.forgetotpandregister = this.forgetotpandregister.bind(this);
    }

    notify = (mode, msg) => {
        Swal.fire({
            title: mode + '!',
            text: msg,
            icon: mode,
            confirmButtonText: 'ตกลง'
        })
    }

    radiocheck(input) {
        console.log(input);
        this.setState({
            bankselect: input
        });
        if (input === 99) {
            this.setState({
                trueaccount: false
            });
        }
        else {
            this.setState({
                trueaccount: true,
                fname: ""
            });
        }
    }

    forgetotpandregister = async (type) => {
        const { phoneNumber, otpphoneforget, bankselect, otpphone, accnumbertxt } = this.state;
        var recheck = false;

        if (type === 4) {
            await instance.post("/api/v1/resetpassword", {
                username: phoneNumber,
                System: Systems,
                type: type
            }).then(async (res) => {
                recheck = res.data.message;
            });
        }
        else if (type === 5) {
            await instance.post("/api/v1/resetpassword", {
                username: phoneNumber,
                pin: otpphoneforget,
                System: Systems,
                type: type
            }).then(async (res) => {
                recheck = res.data.message;
            });
        }
        else if (type === 6) {
            await instance.post("/api/v1/resetpassword", {
                username: phoneNumber,
                System: Systems,
                type: type
            }).then(async (res) => {
                recheck = res.data.message;
            });
        }
        else if (type === 7) {
            await instance.post("/api/v1/resetpassword", {
                username: phoneNumber,
                pin: otpphone,
                System: Systems,
                type: type
            }).then(async (res) => {
                recheck = res.data.message;
            });
        }
        else if (type === 10) {
            return await instance.post("/api/v1/resetpassword", {
                accountnumber: accnumbertxt || "",
                bankid: bankselect,
                System: Systems,
                type: type
            }).then(async (res) => {
                return recheck = res.data.message;
            });
        }

        return recheck
    }

    componentDidUpdate(prevProps) {
        if (prevProps.userrecomend !== this.props.userrecomend) {
            this.setState({
                userrecomend: this.props.userrecomend || ""
            });
        }
    }

    nextstep = async (e, num) => {
        e.preventDefault();

        const {
            stateregis,
            password,
            bankselect,
            passwordcf,
            phoneNumber,
            checkboxacc,
            fname,
            otpphone,
            accnumbertxt
        } = this.state

        console.log(5565656, num);

        if (num === 1) {
            const check = await this.forgetotpandregister(6);

            console.log(phoneNumber.length === 10 && check.checked)
            if (phoneNumber.length === 10 && check.checked) {
                this.setState({
                    stateregis: 2
                });
            }
            else {
                if (phoneNumber.length !== 10) {
                    await this.notify("warning", 'คุณใส่เบอร์ผิดพลาด');
                }
                else if (!check.checked && check.status === 201) {
                    await this.notify("warning", 'เบอร์นี้มีคนใช้แล้ว');
                }
                else {
                    await this.notify("warning", 'คุณทำรายการถี่เกินไป โปรดรอซักครู่');
                    this.setState({
                        stateopterror: "คุณทำรายการถี่เกินไป โปรดรอซักครู่"
                    });
                }
            }
        }
        else if (num === 2) {
            if (password !== passwordcf) {
                await this.notify("warning", 'คุณไส่พาสเวิดไม่ตรงกัน');
            }
            else {
                this.setState({
                    stateregis: 3
                });
            }
        }
        else if (num === 3) {
            if (checkboxacc !== 0 && fname !== "" && accnumbertxt !== "") {
                this.setState({
                    stateregis: 3
                });
            }
            else {
                await this.notify("warning", 'กรุณาเลือกธนาคาร หรือใส่ข้อมูลให้ครบถ้วน');
            }
        }
        else if (num === 5) {
            var check = await this.forgetotpandregister(7);
            if (otpphone !== "" && check.checked) {
                this.setState({
                    stateregis: 2
                });
            }
            else if (otpphone === "" || otpphone.length < 4) {
                await this.notify("warning", 'คุณใส่ตัวเลขไม่ครบ');
                document.getElementById("otpphone").style = "border-color: #ef4444;";
                document.getElementById("checkotp").style.display = "block";
            }
            else {
                await this.notify("warning", 'รหัสผิดพลาด');
                document.getElementById("otpphone").style = "border-color: #ef4444;";
                document.getElementById("checkotp").style.display = "block";
            }
        }
        else if (num === 11) {
            console.log(1, stateregis, num);

            this.setState({
                stateregis: 1
            });
        }
        else if (num === 22) {
            this.setState({
                stateregis: 2
            });
        }
        else if (num === 25) {
            if (accnumbertxt === "" || typeof accnumbertxt === "undefined") {
                var title = 'error'
                var text = 'คุณไม่ทำการใส่เลขบัญชีธนาคาร'
                var object = { title, text }
                this.modalerror(object);
            }
            else if (accnumbertxt.length < 10) {
                var title = 'error'
                var text = 'เลขบัญชีไม่ถูกต้อง'
                var object = { title, text }
                this.modalerror(object);
            }
            else if (bankselect === 0) {
                var title = 'error'
                var text = 'คุณยังไม่ได้เลือกธนาคาร'
                var object = { title, text }
                this.modalerror(object);
            }
            else {
                this.setState({
                    loading: true,
                });

                if (fname === '') {
                    let check = await this.forgetotpandregister(10)
                    if (check.checked) {
                        console.log(302, check.verifications);
                        console.log(302, check.verifications.name);

                        if (check.verifications.status === 0) {
                            this.setState({
                                trueaccount: false,
                            });
                        }
                        else if (check.verifications.status === 1) {
                            this.setState({
                                fname: check.verifications.name,
                            });
                            await this.validatergisterForm(e, check.verifications.name);
                        }
                    }
                    else {
                        var title = 'error'
                        var text = 'เลขบัญชีไม่ถูกต้อง'
                        var object = { title, text }
                        this.modalerror(object);
                    }
                }
                else {
                    await this.validatergisterForm(e, fname)
                }

                this.setState({
                    loading: false,
                });
            }
        }
    };

    onChangex = (event) => {
        if (event.target !== undefined) {
            let nam;
            let val;

            if (event.target.name === "otpphone") {
                document.getElementById("otpphone").style = "";
                document.getElementById("checkotp").style.display = "none";
            }
            else if (event.target.name === "otpphoneforget") {
                document.getElementById("otpphoneforget").style = "";
                document.getElementById("checkotpforget").style.display = "none";
            }
            else if (event.target.name === "otpphoneforget") {
                document.getElementById("phoneNumber").style = "";
                document.getElementById("checkotpforgetphonenormal").style.display = "none";
            }

            if (event.target.name === undefined) {
                nam = event.name;
                val = event.value;
            } else {
                nam = event.target.name;
                val = event.target.value;
            }

            if (nam === "accnumbertxt") {
                val = String(val || "").replace(/\D/g, "").slice(0, 12);
            }

            this.setState({ [nam]: val });
        }
    };

    async modalerror(object) {
        await this.notify(object.title, object.text);
    }

    validatergisterForm = async (e, fname) => {
        e.preventDefault();

        const { phoneNumber, password, passwordcf, bankselect, accnumbertxt } = this.state;
        const useradvise = this.props.userrecomend || this.state.userrecomend || "";

        console.log(bankselect);
        console.log(this.state);

        if (accnumbertxt === "" || typeof accnumbertxt === "undefined") {
            var title = 'error';
            var text = 'คุณไม่ทำการใส่เลขบัญชีธนาคาร';
            var object = { title, text };
            this.modalerror(object);
        }
        else if (accnumbertxt.length < 10) {
            var title = 'error';
            var text = 'เลขบัญชีไม่ถูกต้อง';
            var object = { title, text };
            this.modalerror(object);
        }
        else if (fname === "") {
            var title = 'error';
            var text = 'คุณไม่ทำการใส่ ชื่อ-นามสกุล';
            var object = { title, text };
            this.modalerror(object);
        }
        else if (password.length > 15) {
            var title = 'error';
            var text = 'พาสเวิดสูงสุดไม่เกิน 15 ตัว';
            var object = { title, text };
            this.modalerror(object);
        }
        else if (password.length < 4) {
            var title = 'error';
            var text = 'พาสเวิดต่ำสุดไม่เกิน 4 ตัว';
            var object = { title, text };
            this.modalerror(object);
        }
        else if (password != passwordcf) {
            var title = 'error';
            var text = 'รหัสยิืนยันไม่ตรงกัน';
            var object = { title, text };
            this.modalerror(object);
        }
        else {
            await instance.post("/api/v1/register", {
                User_id: phoneNumber,
                name: fname,
                password: password,
                accbank: bankselect,
                accno: accnumbertxt || "",
                System: Systems,
                Useradvise: useradvise
            }).then(async (res) => {
                console.log(res.data);

                if (res.data.status === 200) {
                    var title = 'success';
                    var text = 'ทำการสมัครเรียบร้อย กรุณารอซักครู่';
                    var object = { title, text };
                    await this.modalerror(object);
                    console.log(302,  phoneNumber, password, Systems);
                    await instance.post("/api/v1/userlogin", {
                        userid: phoneNumber,
                        password: password,
                        System: Systems,
                        Function: 'validateLoginForm-navbar.js'
                    }).then((res) => {
                        console.log("Login Response:", res.data);
                        if (res.status === 200 && res.data.status === 200) {
                            localStorage.setItem('auth_token', res.data.token);
                            setTimeout(() => {
                                window.location.href = '/';
                            }, 1500);
                        }
                    });
                }
                else if (res.data.status === 203) {
                    var title = 'error';
                    var text = 'เลขบัญชี นี้ทำการสมัครไปแล้ว';
                    var object = { title, text };
                    this.modalerror(object);
                }
                else if (res.data.status === 202) {
                    var title = 'error';
                    var text = 'Username นี้ทำการสมัครไปแล้ว';
                    var object = { title, text };
                    this.modalerror(object);
                }
                else {
                    var title = 'error';
                    var text = 'Username หรือ ชื่อในการสมัครไม่ถูกต้อง';
                    var object = { title, text };
                    this.modalerror(object);
                }
            });
        }
    };

    changepass = (e) => {
        e.preventDefault();
        this.setState({
            showpass: this.state.showpass ? false : true,
        });
    }

    async componentDidMount() {
        if (this.props.userrecomend) {
            this.setState({
                userrecomend: this.props.userrecomend
            });
        }

        await instance.post("/api/v1/mainsetting", {
            System: Systems,
        }).then((res) => {
            if (res.data.status === 200) {
                const datas = res.data.message;
                var min = res.data.tblcatagoryx[0].limitdeposit;
                var max = res.data.tblcatagoryx[0].maxdeposit;
                var limit = { min, max }
                this.setState({
                    linelink: datas[1].value,
                    tblbank: res.data.tblbank,
                    logoimg: res.data.tblsetting[0].imglogo,
                    System: res.data.tblcatagoryx[0].System,
                    limit: limit
                });
            }
            else {
                // this.CheckThisGoalError();
            }
        });
        //  this.nameInput.focus();
    }

    render() {
        const { stateopterror, tblbank } = this.state
        return (
            <>
                <div className="-games-provider-wrapper pl-0 pr-0 mx-auto -menu-index-page-bg col-12">
                    {/**/}
                </div>
                <div className="-games-index-page col-12">
                    <div className="mb-2 text-white-v1">
                        <div className="d-none d-lg-block">
                        </div>
                        {/**/}
                        <div className="padding-router-view">
                            <div className="">
                                <div className=" m-3">
                                    <div className="container">
                                        <div className="row">
                                            <div className="pt-5 text-white-v1 text-center col col-sm-8 col-md-10 col-lg-8 col-xl-5 pl-0 pr-0 mx-auto my-auto">

                                                <br />
                                                <div className="x-modal-separator-container x-login-form  bg-signIn neon-auth-box">
                                                    <div className="-top">
                                                        <div data-animatable="fadeInModal" className="animated fadeInModal">
                                                            <div className="text-font-title-signin text-white-v1 mt-2 pt-2">
                                                                <img
                                                                    src={this.state.logoimg}
                                                                    className="logo-w-signIn-v113"
                                                                    alt=""
                                                                />
                                                            </div>
                                                            <div className="-img-container text-center">
                                                            </div>

                                                            <form autoComplete="new-password" style={{ marginTop: "-10px" }}>
                                                                <div className="x-modal-separator-container x-login-form pb-3  bg-signup">
                                                                    <div className="-top" style={{ display: this.state.stateregis === 1 ? "" : "none" }}>
                                                                        <div className="-fake-inner-body">
                                                                            <div className="x-step-register">
                                                                                <div className="px-0 m-auto -container-wrapper">
                                                                                    <div className="-step-box-outer step-active" />
                                                                                    <div className="-step-box-outer" />
                                                                                    <div className="-step-box-outer" />
                                                                                    <div className="-step-box-outer" />
                                                                                </div>
                                                                            </div>
                                                                            <div>
                                                                                <div className="-img-container text-white text-center">
                                                                                    <h6><span id='menu183'>สมัครสมาชิกด้วยเบอร์โทรศัพท์</span></h6>
                                                                                </div>
                                                                                <div className="-x-input-icon mb-1 text-center text-center">
                                                                                    <div className="input-group mb-2">
                                                                                        <span
                                                                                            className="input-group-text bg-border-input-icon"
                                                                                            id="basic-addon1"
                                                                                        >
                                                                                            <img
                                                                                                className="-icon"
                                                                                                alt="EZ Slot"
                                                                                                width={15}
                                                                                                height={15}
                                                                                                src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/c8d943f5-025b-4bee-ee2e-752b3e427d00/public"
                                                                                            />
                                                                                        </span>
                                                                                        <input
                                                                                            onChange={this.onChangex}
                                                                                            type="text"
                                                                                            id="phoneNumber"
                                                                                            name="phoneNumber"
                                                                                            className="form-control form-control-form bg-border-input"
                                                                                            maxLength={10}
                                                                                            minLength={10}
                                                                                            aria-label="phoneNumber"
                                                                                            placeholder={"xxx-xxxxxxxx"}
                                                                                        />
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                            <div className="text-center">
                                                                                <div />
                                                                                <div>
                                                                                    <div className="mt-1 mb-2">
                                                                                        <div>
                                                                                            <button
                                                                                                ref={(input) => { this.nameInput = input; }}
                                                                                                onClick={(e) => {
                                                                                                    this.nextstep(e, 1)
                                                                                                }}
                                                                                                className="btn -submit js-submit-accept-term rounded-pill v-login mt-lg-1 mt-0 w-100 p-2">
                                                                                                <span><span id='menu184'>ถัดไป</span></span>
                                                                                            </button>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>

                                                                    <div className="-top" style={{ display: this.state.stateregis === 2 ? "" : "none" }}>
                                                                        <div className="-fake-inner-body">
                                                                            <div className="x-step-register">
                                                                                <div className="px-0 m-auto -container-wrapper">
                                                                                    <div className="-step-box-outer step-active" />
                                                                                    <div className="-step-box-outer step-active" />
                                                                                    <div className="-step-box-outer step-active" />
                                                                                    <div className="-step-box-outer" />
                                                                                </div>
                                                                            </div>
                                                                            <div>
                                                                                <div className="-img-container text-center" style={{ color: "white" }}>
                                                                                    <h6><span id='menu186'>รหัสผ่าน</span></h6>
                                                                                </div>
                                                                                <div className="mb-1 text-center">
                                                                                    <div className="-x-input-icon flex-column">
                                                                                        <div className="input-group mb-3">
                                                                                            <span className="input-group-text bg-border-input-icon">
                                                                                                <img
                                                                                                    className="-icon"
                                                                                                    alt="EZ Slot"
                                                                                                    width={15}
                                                                                                    height={15}
                                                                                                    src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/bb8fe716-5b2a-4b92-60ff-7608db842e00/public"
                                                                                                />
                                                                                            </span>
                                                                                            <input
                                                                                                onChange={this.onChangex}
                                                                                                type={!this.state.showpass ? "text" : "password"}
                                                                                                id="password"
                                                                                                name="password"
                                                                                                className="form-control form-control-form border-r-0"
                                                                                                placeholder="password"
                                                                                            />
                                                                                            <span
                                                                                                className="input-group-text bg-border-input-icon-eye"
                                                                                                id="change-eye"
                                                                                                role="button"
                                                                                                onClick={(e) => this.changepass(e)}
                                                                                            >
                                                                                                <svg
                                                                                                    style={{ display: (!this.state.showpass) ? "none" : "" }}
                                                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                                                    width={16}
                                                                                                    height={16}
                                                                                                    fill="currentColor"
                                                                                                    className="bi bi-eye-slash"
                                                                                                    viewBox="0 0 16 16"
                                                                                                >
                                                                                                    <path d="M13.359 11.238C15.06 9.72 16 8 16 8s-3-5.5-8-5.5a7.028 7.028 0 0 0-2.79.588l.77.771A5.944 5.944 0 0 1 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.134 13.134 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755-.165.165-.337.328-.517.486l.708.709z" />
                                                                                                    <path d="M11.297 9.176a3.5 3.5 0 0 0-4.474-4.474l.823.823a2.5 2.5 0 0 1 2.829 2.829l.822.822zm-2.943 1.299.822.822a3.5 3.5 0 0 1-4.474-4.474l.823.823a2.5 2.5 0 0 0 2.829 2.829z" />
                                                                                                    <path d="M3.35 5.47c-.18.16-.353.322-.518.487A13.134 13.134 0 0 0 1.172 8l.195.288c.335.48.83 1.12 1.465 1.755C4.121 11.332 5.881 12.5 8 12.5c.716 0 1.39-.133 2.02-.36l.77.772A7.029 7.029 0 0 1 8 13.5C3 13.5 0 8 0 8s.939-1.721 2.641-3.238l.708.709zm10.296 8.884-12-12 .708-.708 12 12-.708.708z" />
                                                                                                </svg>

                                                                                                <svg
                                                                                                    style={{ display: (this.state.showpass) ? "none" : "" }}
                                                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                                                    width={16}
                                                                                                    height={16}
                                                                                                    fill="currentColor"
                                                                                                    className="bi bi-eye"
                                                                                                    viewBox="0 0 16 16"
                                                                                                >
                                                                                                    <path d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8zM1.173 8a13.133 13.133 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.133 13.133 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5c-2.12 0-3.879-1.168-5.168-2.457A13.134 13.134 0 0 1 1.172 8z" />
                                                                                                    <path d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zM4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0z" />
                                                                                                </svg>
                                                                                            </span>
                                                                                        </div>

                                                                                        <div className="input-group mb-3">
                                                                                            <span className="input-group-text bg-border-input-icon">
                                                                                                <img
                                                                                                    className="-icon"
                                                                                                    alt="EZ Slot"
                                                                                                    width={15}
                                                                                                    height={15}
                                                                                                    src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/bb8fe716-5b2a-4b92-60ff-7608db842e00/public"
                                                                                                />
                                                                                            </span>
                                                                                            <input
                                                                                                onChange={this.onChangex}
                                                                                                type={!this.state.showpass ? "text" : "password"}
                                                                                                id="passwordcf"
                                                                                                name="passwordcf"
                                                                                                className="form-control form-control-form border-r-0"
                                                                                                placeholder="password"
                                                                                            />
                                                                                            <span
                                                                                                className="input-group-text bg-border-input-icon-eye"
                                                                                                id="change-eye"
                                                                                                role="button"
                                                                                                onClick={(e) => this.changepass(e)}
                                                                                            >
                                                                                                <svg
                                                                                                    style={{ display: (!this.state.showpass) ? "none" : "" }}
                                                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                                                    width={16}
                                                                                                    height={16}
                                                                                                    fill="currentColor"
                                                                                                    className="bi bi-eye-slash"
                                                                                                    viewBox="0 0 16 16"
                                                                                                >
                                                                                                    <path d="M13.359 11.238C15.06 9.72 16 8 16 8s-3-5.5-8-5.5a7.028 7.028 0 0 0-2.79.588l.77.771A5.944 5.944 0 0 1 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.134 13.134 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755-.165.165-.337.328-.517.486l.708.709z" />
                                                                                                    <path d="M11.297 9.176a3.5 3.5 0 0 0-4.474-4.474l.823.823a2.5 2.5 0 0 1 2.829 2.829l.822.822zm-2.943 1.299.822.822a3.5 3.5 0 0 1-4.474-4.474l.823.823a2.5 2.5 0 0 0 2.829 2.829z" />
                                                                                                    <path d="M3.35 5.47c-.18.16-.353.322-.518.487A13.134 13.134 0 0 0 1.172 8l.195.288c.335.48.83 1.12 1.465 1.755C4.121 11.332 5.881 12.5 8 12.5c.716 0 1.39-.133 2.02-.36l.77.772A7.029 7.029 0 0 1 8 13.5C3 13.5 0 8 0 8s.939-1.721 2.641-3.238l.708.709zm10.296 8.884-12-12 .708-.708 12 12-.708.708z" />
                                                                                                </svg>

                                                                                                <svg
                                                                                                    style={{ display: (this.state.showpass) ? "none" : "" }}
                                                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                                                    width={16}
                                                                                                    height={16}
                                                                                                    fill="currentColor"
                                                                                                    className="bi bi-eye"
                                                                                                    viewBox="0 0 16 16"
                                                                                                >
                                                                                                    <path d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8zM1.173 8a13.133 13.133 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.133 13.133 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5c-2.12 0-3.879-1.168-5.168-2.457A13.134 13.134 0 0 1 1.172 8z" />
                                                                                                    <path d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zM4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0z" />
                                                                                                </svg>
                                                                                            </span>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>

                                                                            <div className="text-center">
                                                                                <div className="m-auto -term-and-condition-check-box">
                                                                                    <div className="x-checkbox-primary d-flex justify-content-center">
                                                                                        <a
                                                                                            onClick={(e) => {
                                                                                                this.nextstep(e, 11)
                                                                                            }}
                                                                                            role="button"
                                                                                            className="text-white-v1">
                                                                                            <span id='menu187'>ยกเลิก</span>
                                                                                        </a>
                                                                                    </div>
                                                                                </div>
                                                                                <div />
                                                                                <div>
                                                                                    <div className="mt-1 mb-2">
                                                                                        <div>
                                                                                            <button
                                                                                                onClick={(e) => {
                                                                                                    this.nextstep(e, 2)
                                                                                                }}
                                                                                                className="btn -submit js-submit-accept-term rounded-pill v-login mt-lg-1 mt-0 w-100 p-2">
                                                                                                <span><span id='menu188'>ถัดไป</span></span>
                                                                                            </button>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>

                                                                    <div className="-top" style={{ display: this.state.stateregis === 3 ? "" : "none" }}>
                                                                        <div className="-fake-inner-body">
                                                                            <div className="x-step-register">
                                                                                <div className="px-0 m-auto -container-wrapper">
                                                                                    <div className="-step-box-outer step-active" />
                                                                                    <div className="-step-box-outer step-active" />
                                                                                    <div className="-step-box-outer step-active" />
                                                                                    <div className="-step-box-outer step-active" />
                                                                                </div>
                                                                            </div>
                                                                            <div>
                                                                                <div className="-img-container text-center" style={{ color: "white" }}>
                                                                                    <h6><span id='menu190'>กรุณาเลือกธนาคาร</span></h6>
                                                                                </div>
                                                                                <div className="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-12 css-15j76c0">
                                                                                    <div className="inputPaddingRegisterTop">
                                                                                        <div className="MuiGrid-root MuiGrid-container MuiGrid-spacing-xs-1 css-tuxzvu">
                                                                                            {tblbank.map((listitem, i) => (
                                                                                                <a
                                                                                                    key={i}
                                                                                                    className="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-2 css-o0rlmm"
                                                                                                    onClick={(e) => {
                                                                                                        this.radiocheck(listitem.bank_id)
                                                                                                    }}
                                                                                                >
                                                                                                    <img
                                                                                                        className={this.state.bankselect == listitem.bank_id ? "imgBankNotSelect" : "imgBank"}
                                                                                                        src={listitem.img_path}
                                                                                                        alt="bank list"
                                                                                                    />
                                                                                                </a>
                                                                                            ))}
                                                                                        </div>
                                                                                    </div>
                                                                                </div>

                                                                                <div className="input-group mt-2">
                                                                                    <span
                                                                                        className="input-group-text bg-border-input-icon"
                                                                                        id="basic-addon1"
                                                                                    >
                                                                                        <img
                                                                                            className="-icon"
                                                                                            alt="EZ Slot"
                                                                                            width={15}
                                                                                            height={15}
                                                                                            src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/bb8fe716-5b2a-4b92-60ff-7608db842e00/public"
                                                                                        />
                                                                                    </span>
                                                                                    <input
                                                                                        onChange={this.onChangex}
                                                                                        value={this.state.accnumbertxt}
                                                                                        id="accnumbertxt"
                                                                                        inputMode="numeric"
                                                                                        pattern="[0-9]*"
                                                                                        maxLength={12}
                                                                                        name="accnumbertxt"
                                                                                        required="required"
                                                                                        className="form-control form-control-form border-r-0"
                                                                                        aria-label="member_accid"
                                                                                        placeholder={"เลขบัญชี"}
                                                                                    />
                                                                                </div>

                                                                                <div className="input-group mt-2" style={{ display: this.state.trueaccount ? "none" : "" }}>
                                                                                    <span
                                                                                        className="input-group-text bg-border-input-icon"
                                                                                        id="basic-addon1"
                                                                                    >
                                                                                        <img
                                                                                            className="-icon"
                                                                                            alt="EZ Slot"
                                                                                            width={15}
                                                                                            height={15}
                                                                                            src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/84f8435d-3a19-4e45-eb3c-57f582263300/public"
                                                                                        />
                                                                                    </span>
                                                                                    <input
                                                                                        type="text"
                                                                                        onChange={this.onChangex}
                                                                                        id="fname"
                                                                                        value={this.state.fname}
                                                                                        name="fname"
                                                                                        required="required"
                                                                                        className="form-control form-control-form border-r-0"
                                                                                        aria-label="member_accid"
                                                                                        placeholder={"ชื่อบัญชี"}
                                                                                    />
                                                                                </div>
                                                                            </div>

                                                                            <div className="text-center">
                                                                                <div className="m-auto -term-and-condition-check-box">
                                                                                    <div className="x-checkbox-primary d-flex justify-content-center">
                                                                                        <a
                                                                                            onClick={(e) => {
                                                                                                this.nextstep(e, 11)
                                                                                            }}
                                                                                            role="button"
                                                                                            className="text-white-v1">
                                                                                            <span id='menu191'>ยกเลิก</span>
                                                                                        </a>
                                                                                    </div>
                                                                                </div>
                                                                                <div />
                                                                                <div>
                                                                                    <div>
                                                                                        <a
                                                                                            onClick={(e) => {
                                                                                                this.nextstep(e, 25)
                                                                                            }}
                                                                                            disabled={this.state.loading}
                                                                                            type="submit"
                                                                                            role="button"
                                                                                            className="btn -submit js-submit-accept-term rounded-pill v-login mt-lg-1 mt-0 w-100 p-2"
                                                                                        >
                                                                                            <div style={{ display: this.state.loading ? "" : "none" }}>
                                                                                                <span className="spinner-border" role="status">
                                                                                                    <span className="visually-hidden">Loading...</span>
                                                                                                </span>
                                                                                            </div>
                                                                                            <div style={{ display: this.state.loading ? "none" : "" }}>
                                                                                                <span id='menu192'>ยืนยัน</span>
                                                                                            </div>
                                                                                        </a>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </form>

                                                            <div className="mt-3">
                                                                <div className="row m-0">
                                                                    <div className="col-6 col-md-6">
                                                                        <button
                                                                            className="btn -submit js-submit-accept-term rounded-pill v-login mt-lg-1 mt-0 w-100 p-2"
                                                                            onClick={(e) => {
                                                                                e.preventDefault();
                                                                                window.location.href = '/signin';
                                                                            }}
                                                                        >
                                                                            <svg
                                                                                xmlns="http://www.w3.org/2000/svg"
                                                                                width={15}
                                                                                height={15}
                                                                                fill="currentColor"
                                                                                className="bi bi-person-fill"
                                                                                viewBox="0 0 16 16"
                                                                            >
                                                                                <path d="M3 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H3Zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z" />
                                                                            </svg>
                                                                            <span><span id='menu194'>เข้าสู่ระบบ</span></span>
                                                                        </button>
                                                                    </div>
                                                                    <div className="col-6 col-md-6">
                                                                        <a href={this.state.linelink} className="btn -submit js-submit-accept-term btn-success v-login-contact mt-lg-1 mt-0 w-100 p-2">
                                                                            <svg
                                                                                xmlns="http://www.w3.org/2000/svg"
                                                                                width={15}
                                                                                height={15}
                                                                                fill="currentColor"
                                                                                className="bi bi-telephone-fill"
                                                                                viewBox="0 0 16 16"
                                                                            >
                                                                                <path
                                                                                    fillRule="evenodd"
                                                                                    d="M1.885.511a1.745 1.745 0 0 1 2.61.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.678.678 0 0 0 .178.643l2.457 2.457a.678.678 0 0 0 .644.178l2.189-.547a1.745 1.745 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.634 18.634 0 0 1-7.01-4.42 18.634 18.634 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877L1.885.511z"
                                                                                />
                                                                            </svg>
                                                                            <span><span id='menu195'>ติดต่อเรา</span></span>
                                                                        </a>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div >
                </div >
            </>
        );
    }
}

export default App;